import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { dubaiDate, dubaiTimeHM } from '../../../../utils/dubaiTime';

const LaundryDetailsData = ({ bookingId }) => {
    const [details, setDetails] = useState(null);
    const [userRole] = useState(localStorage.getItem('userRole'));
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDetails = async () => {
            try {
                const res = await axios.get(`/api/laundry/${bookingId}`);
                setDetails(res.data);
            } catch (err) {
                console.error("Error fetching laundry details:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchDetails();
    }, [bookingId]);

    // Asia/Dubai renders (item 8) — same dd/mm/yyyy and HH:mm visuals.
    const formatDate = (d) => (d ? dubaiDate(d) || 'N/A' : 'N/A');
    const formatTime = (t) => (t ? dubaiTimeHM(t) || 'N/A' : 'N/A');

    const statusConfig = {
        created: 'Waiting for warehouse confirmation',
        processing: 'Processing',
        flagged: 'Incorrect Warehouse Confirmation',
        completed: 'Packed & Ready',
        before_photo: 'Awaiting Before Photos',
        stains_reported: 'Stains Reported',
        delivered: 'Delivered',
    };

    if (loading || !details) return <p>Loading details...</p>;

    const {
        comment,
        created_at,
        property_id,
        status,
        is_linen_hire,
        is_laundry_count_lh,
        created_by_first_name,
        confirmed_by_first_name,
        confirmed_at,
        packed_by_first_name,
        packed_at,
        bags
    } = details;

    return (
        <div className="laundry-details-data">
            <div className="detail-column">
                <p><strong>Created At:</strong> {formatDate(created_at)}</p>
                <p><strong>Property ID:</strong> #{property_id?.toString().padStart(5, '0') || 'N/A'}</p>
                <p><strong>Status:</strong> {statusConfig[status] || 'Unknown'}</p>
                <p><strong>Comment:</strong> {comment || 'NA'}</p>
            </div>
            <div className="detail-column">
                <p><strong>Created By:</strong> {created_by_first_name || 'N/A'}</p>
                <p>
                    <strong>Confirmed By:</strong> {confirmed_by_first_name || 'NA'}
                    {userRole === 'manager' && (
                        <span>, {formatDate(confirmed_at)} {formatTime(confirmed_at)}</span>
                    )}
                </p>
                <p>
                    <strong>Packed By:</strong>{' '}
                    {packed_by_first_name
                        ? `${packed_by_first_name}, ${bags} bag${bags > 1 ? 's' : ''}${userRole === 'manager' && packed_at ? `, ${formatDate(packed_at)} ${formatTime(packed_at)}` : ''}`
                        : 'NA'}
                </p>
                {is_laundry_count_lh ? (
                    <p style={{ color: '#FF5A60', fontWeight: '700' }}>Linen Hire</p>
                ) : is_linen_hire ? (
                    <p><strong>Client Items for LH Unit</strong></p>
                ) : null}
            </div>
        </div>
    );
};

export default LaundryDetailsData;